/* raw layout hash: _wallet-top-up-payment-layout:5ec35021f4f0467a13b026bbb1ba1d5e8946d43f6736ab027f0b83f44829e77e */
import React from 'react';
import AppShell from './AppShell.jsx';

// Raw layout: _wallet-top-up-payment-layout.html — top navbar + mobile bottom bar. Menu entries are role-based (see AppShell / menuData.js).

export default function WalletTopUpPaymentLayout() {
  return <AppShell />;
}
